import {
  MY_JOURNEY,
  OVERVIEW,
  SBUSCRIPTION_ADMIN,
  COMPANY_GENERAL,
  OHEP_SURVEYS,
  GOALS,
  CHECK_QUIZZES_RESULT_EXPORT,
  USER_PROGRESS_REPORT,
  FEATURES_ADMIN,
  DEMO_ACCOUNTS,
  ROLE_PLAY_PRACTISES,
  MEETINGS
} from 'routes/constants'

// Labels are mapped from i18n translation files
export const managerTabs = [
  { value: OVERVIEW, label: 'overview' },
  { value: COMPANY_GENERAL, label: 'company' }
]

export const contentTabs = [
  {
    value: MY_JOURNEY,
    label: 'myJourney'
  },
  {
    value: MEETINGS,
    label: 'meetings',
    tag: 'beta'
  }
]

export const goalContentTabs = [
  { value: ROLE_PLAY_PRACTISES, label: 'practice' }
]

export const raterTabs = contentTabs

export const fullAssessmentTabs = [
  {
    value: MY_JOURNEY,
    label: 'home'
  }
]

export const testingTabs = [
  { value: SBUSCRIPTION_ADMIN, label: 'subscriptions' },
  {
    value: GOALS,
    label: 'paths'
  },
  {
    value: 'reports',
    label: 'reportExport',
    pages: [
      {
        value: OHEP_SURVEYS,
        label: 'ohepSurveys'
      },
      {
        value: CHECK_QUIZZES_RESULT_EXPORT,
        label: 'learningCheckQuizzesResults'
      },
      {
        value: USER_PROGRESS_REPORT,
        label: 'userProgressReport'
      }
    ]
  },
  { value: FEATURES_ADMIN, label: 'features' },
  {
    value: DEMO_ACCOUNTS,
    label: 'demoAccounts'
  }
]
